export default __webpack_public_path__ + "static/media/b_aimingHigh_large.40c3bb04.png";